import React from 'react';
import { NavLink } from 'react-router-dom';
import './SideBar.css';

const SideBar = () => {
    return (
        <div className="carousel-list">
                    <ul>
                        <li className="first-link"><NavLink activeClass="nav-active" to="/dashboard" className="link" style={{textDecoration:'none',color:'black'}}><span>Service list</span></NavLink></li>
                        <li className="second-link"><NavLink activeClass="nav-active" to="/addService" className="link"  style={{textDecoration:'none',color:'black'}}><span>Add service</span></NavLink></li>
                        <li className="third-link"><NavLink activeClass="nav-active" to="/makeAdmin" className="link"  style={{textDecoration:'none',color:'black'}}><span>Make admin</span></NavLink></li>
                    </ul>
                </div>
    );
};

export default SideBar;